import { t } from '@lingui/macro';
import { i18n } from '../helpers/i18n';
interface Breadcrumb {
  name: string;
  url: string;
  shortText?: string;
}
/* eslint-disable @typescript-eslint/no-inferrable-types */
const breadcrumbs = (path: string = ''): Breadcrumb[] => {
  const allBreadcrumbs: Breadcrumb[] = [
    {
      url: i18n._(t`/services/catalog/popular/`),
      name: i18n._(t`Услуги`),
    },
    {
      url: i18n._(t`/services/catalog/cat/54532/`),
      name: i18n._(t`Социальная поддержка`),
      shortText: i18n._(t`Социальная ...`),
    },
    {
      url: i18n._(
        t`/services/poluchenie-i-prodlenie-statusa-mnogodetnoi-semyi/`
      ),
      name: i18n._(t`Получение и продление статуса многодетной семьи`),
      shortText: i18n._(t`Получение и продление...`),
    },
    {
      url: i18n._(
        t`/services/poluchenie-i-prodlenie-statusa-mnogodetnoi-semyi/new/`
      ),
      name: i18n._(
        t`Присвоение (продление) льготного статуса многодетной семьи города...`
      ),
    },
  ];

  if (path.match(new RegExp(`^/(success|new|queue|error)/?$`))) {
    return allBreadcrumbs.map((item) => ({
      ...item,
      name: item.shortText ? item.shortText : item.name,
    }));
  }

  return allBreadcrumbs.filter(
    (n, index) => index !== allBreadcrumbs.length - 1
  );
};

export default breadcrumbs;
